<template>
  <div>
    <component :is="pageView" @change-page="changePage" v-bind="$attrs" />
  </div>
</template>

<script setup>
import home from './home';
import enter from './enter';
import kaipiao from './kaipiao';
import queren from './queren';
import redTicketConfirm from '../redTicketConfirm'

const pageView = shallowRef(home);

function changePage(page) {
  switch (page) {
    case 'redInvoice_home':
      pageView.value = home;
      break;
    case 'redInvoice_enter':
      pageView.value = enter;
      break;
    case 'redInvoice_kaipiao':
      pageView.value = kaipiao;
      break;
    case 'redInvoice_queren':
      pageView.value = queren;
      break;
    case 'redInvoice_confirm':
      pageView.value = redTicketConfirm
      break
  }
}
</script>

<style lang="scss" scoped></style>
